export const links = {
  docs: {
    eMode: 'https://docs.spark.fi/defi-infrastructure/sparklend/spark-lend-features#high-efficiency-mode-e-mode',
    isolationMode: 'https://docs.spark.fi/defi-infrastructure/sparklend/spark-lend-features#isolation-mode',
    siloedMode: 'https://docs.spark.fi/defi-infrastructure/sparklend#siloed-borrowing',
    isolationModeBorrowingPower:
      'https://docs.spark.fi/defi-infrastructure/sparklend/spark-lend-features#how-does-isolation-mode-affect-my-borrowing-power',
    supplyBorrowCaps: 'https://docs.spark.fi/defi-infrastructure/sparklend#supply-and-borrow-caps',
    dsr: 'https://docs.spark.fi/user-guides/earning-savings/sdai-overview#what-is-dsr',
    ssr: 'https://docs.spark.fi/user-guides/earning-savings/savings-usds#what-is-dsr',
    upgradeDai: 'https://docs.spark.fi/user-guides/upgrading-to-usds-and-susds/upgrading-to-usds',
    upgradeSdai: 'https://docs.spark.fi/user-guides/upgrading-to-usds-and-susds/upgrading-to-susds',
    downgradeUsds: 'https://docs.spark.fi/user-guides/upgrading-to-usds-and-susds/downgrading-to-dai',
    newSavings: 'https://docs.spark.fi/user-guides/upgrading-to-usds-and-susds',
    healthFactor: 'https://docs.spark.fi/defi-infrastructure/sparklend/liquidations',
    supplying: 'https://docs.spark.fi/defi-infrastructure/sparklend/supplying-and-earning',
    borrowing: 'https://docs.spark.fi/defi-infrastructure/sparklend/borrowing',
    sparkAirdrop: 'https://docs.spark.fi/governance/spk-token',
    farmingRewards: 'https://docs.spark.fi/user-guides/farming-rewards',
  },
  aaveTechnicalPaper: 'https://github.com/aave/aave-v3-core/blob/master/techpaper/Aave_V3_Technical_Paper.pdf',
  termsOfUse: 'https://spark.fi/terms-of-use.html',
  privacyPolicy: 'https://spark.fi/privacy-policy.html',
  github: 'https://github.com/marsfoundation/spark-app',
} as const
